export const emptyFilter = {
  type: "combined",
  conditionType: "AND",
  conditions: [
    {
      type: "combined",
      conditionType: "AND",
      conditions: [],
    },
    {
      type: "combined",
      conditionType: "OR",
      conditions: [],
    },
  ],
};

export const suppressionTypes = [
  { value: "EMAIL", label: "Email Address" },
  { value: "MD5", label: "MD5 hash" },
  { value: "SHA256", label: "SHA256 hash" },
];
